/**
 * Routes.
 * @module routes
 */

import { App } from '@plone/volto/components';
import { defaultRoutes } from '@plone/volto/routes';
import config from '@plone/volto/registry';
import ArticleSearchPage from './components/Blog/ArticleSearchPage';
import ContactForm from './components/Blog/ContactForm';
import LegacyArticleRedirect from './components/Blog/LegacyArticleRedirect';

/**
 * Routes array.
 * @array
 * @returns {array} Routes.
 */
const routes = [
  {
    path: '/',
    component: App, // Change this if you want a different component
    routes: [
      // Add your routes here
      {
        path: '/contact',
        component: ContactForm,
        exact: true,
      },
      {
        path: '/contact-form',
        component: ContactForm,
        exact: true,
      },
      {
        path: '/articles/search',
        component: ArticleSearchPage,
        exact: true,
      },
      {
        path: '/search',
        component: ArticleSearchPage,
        exact: true,
      },
      {
        path: '/:legacyId([a-z0-9]{6})',
        component: LegacyArticleRedirect,
        exact: true,
      },
      ...(config.addonRoutes || []),
      ...defaultRoutes,
    ],
  },
];

export default routes;
